import { track } from './core';
import { trackingEventNames } from '../../settings/constants';

import IUserActionType from './interfaces/IUserActionType';
import IMediaType from './interfaces/IMediaType';
import IContentActionType from './interfaces/IContentActionType';
import IAnimationInteraction from './interfaces/IAnimationInteraction';

export function track_show_gated_content() {
	const event = {
		event: trackingEventNames.GATED_CONTENT,
	}
	track(event);
}

export function track_gated_content_choice(choice: IUserActionType) {
	const event = {
		event: trackingEventNames.GATED_CONTENT_CHOICE,
		choice: choice,
	}
	track(event);
}

export function track_content_engagement(content_type: IMediaType, content_action: IContentActionType, content_title: string, content_url: string) {
	const event = {
		event: trackingEventNames.CONTENT_ENGAGEMENT,
		content_type: content_type,
		content_action: content_action,
		content_title: content_title,
		content_url: content_url,
	}
	track(event);
}

export function track_animation_interaction(interaction: IAnimationInteraction) {
	const event = {
		event: trackingEventNames.ANIMATION,
		animation_interaction: interaction,
	}
	track(event);
}

export function track_cta_button(button_text: string) {
	const event = {
		event: trackingEventNames.CTA_BUTTON,
		button_text: button_text,
	}
	track(event);
}

export function track_bookmark_event() {
	const event = {
		event: trackingEventNames.BOOKMARK,
		content_type: 'page',
	}
	track(event);
}